/**
 * Configuracion de AdSense en un solo lugar.
 *
 * El sitio venia con Auto ads y nada mas: el cargador en el <head> y ningun bloque
 * declarado. Auto ads decide solo donde pinchar los anuncios, y en una calculadora
 * —donde el contenido util se dibuja en el cliente y el texto vive al pie— suele
 * elegir mal: o los mete arriba de todo y tapan la herramienta, o no encuentra
 * hueco y no muestra ninguno.
 *
 * Un bloque declarado gana en las dos puntas: se sabe donde queda, se le puede
 * reservar el alto (el sitio bajo su CLS de 0,85 a 0,005 y no vale la pena
 * devolverlo) y rinde mas que el mismo espacio elegido por Auto ads.
 *
 * COMO ACTIVARLOS: en AdSense -> Anuncios -> Por unidad de anuncio, crear una unidad
 * "Display" por cada entrada de SLOTS y pegar aca el `data-ad-slot` (los 10 digitos).
 * Mientras el valor este vacio el bloque no se renderiza: no hay hueco, no hay salto
 * de layout y no hay <ins> vacio que AdSense cuente como impresion sin llenar.
 */

export const CLIENTE_ADSENSE = 'ca-pub-8910558649748673'

/*
  Rutas sin anuncios. La politica de AdSense no permite anuncios en paginas sin
  contenido, y estas tres tienen 12, 17 y 19 palabras. Son tambien las tres unicas
  con <meta name='robots' content='noindex'>.

  Vive aca y no en _document.js porque ahora la leen los dos: el cargador del <head>
  y cada bloque. Dos listas separadas se desincronizan en cuanto se agregue una ruta.
*/
export const RUTAS_SIN_ANUNCIOS = ['/404', '/500', '/401']

/**
 * Identificadores de unidad. La clave es el sitio donde se muestra; el valor, el
 * `data-ad-slot` que da AdSense. Vacio = ese bloque no existe todavia.
 */
export const SLOTS = {
  // waotools-tool-footer. Debajo del bloque "How this tool works" de cada
  // herramienta: es el unico punto de la pagina donde el usuario esta leyendo en
  // vez de calculando.
  pieHerramienta: '4590523216',

  // waotools-guide-article. Al cierre del cuerpo del articulo. Las guias son las
  // paginas con texto de verdad, las que mejor pagan y a las que llega la busqueda
  // organica.
  guiaArticulo: '3361202024'
}

/** Un bloque solo se pinta si tiene slot configurado y la ruta admite anuncios. */
export const anunciosPermitidos = ruta => !RUTAS_SIN_ANUNCIOS.includes(ruta.replace(/\/$/, '') || '/')
